import initialOverview from './widgets/initial-overview'
import mediaplans from './widgets/mediaplans'

export default [initialOverview, mediaplans]
